import React, { useState, useEffect, useRef } from 'react';

import { searchLocations } from '../../services/locationService';

import { useTranslation } from 'react-i18next';

import {

  Container,

  Input,

  SuggestionsList,

  SuggestionItem,

  ErrorMessage,

} from './styles';



const LocationAutocomplete = ({ value, onChange, error, placeholder, onLocationSelect }) => {

  const { t } = useTranslation();

  const [suggestions, setSuggestions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const [showSuggestions, setShowSuggestions] = useState(false);

  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);

  const containerRef = useRef(null);



  useEffect(() => {

    // Verifica se a API do Google Maps está carregada

    const checkGoogleMapsLoaded = () => {

      if (window.google && window.google.maps && window.google.maps.places) {

        setIsGoogleMapsLoaded(true);

      }

    };



    // Verifica imediatamente

    checkGoogleMapsLoaded();



    // Configura um intervalo para verificar periodicamente

    const interval = setInterval(checkGoogleMapsLoaded, 100);



    // Limpa o intervalo após 5 segundos ou quando a API estiver carregada

    const timeout = setTimeout(() => {

      clearInterval(interval);

    }, 5000);



    return () => {

      clearInterval(interval);

      clearTimeout(timeout);

    };

  }, []);



  useEffect(() => {

    const handleClickOutside = (event) => {

      if (containerRef.current && !containerRef.current.contains(event.target)) {

        setShowSuggestions(false);

      }

    };



    document.addEventListener('mousedown', handleClickOutside);

    return () => document.removeEventListener('mousedown', handleClickOutside);

  }, []);



  const handleInputChange = async (event) => {

    const query = event.target.value;

    onChange(query);



    if (!isGoogleMapsLoaded) {

      console.log('Aguardando carregamento da API do Google Maps...');

      return;

    }



    if (query.length < 3) {

      setSuggestions([]);

      return;

    }



    setIsLoading(true);

    try {

      const results = await searchLocations(query);

      setSuggestions(results);

      setShowSuggestions(true);

    } catch (error) {

      console.error('Erro ao buscar sugestões:', error);

      setSuggestions([]);

    } finally {

      setIsLoading(false);

    }

  };



  const handleSuggestionClick = (suggestion) => {

    onChange(suggestion.description);

    setShowSuggestions(false);

    if (onLocationSelect) {

      onLocationSelect(suggestion);

    }

  };



  return (

    <Container ref={containerRef}>

      <Input

        type="text"

        value={value}

        onChange={handleInputChange}

        placeholder={placeholder || t('searchResults.search.locationPlaceholder')}

        $error={!!error}

      />

      {showSuggestions && suggestions.length > 0 && (

        <SuggestionsList>

          {suggestions.map((suggestion) => (

            <SuggestionItem

              key={suggestion.id}

              onClick={() => handleSuggestionClick(suggestion)}

            >

              <strong>{suggestion.mainText}</strong>

              <span>{suggestion.secondaryText}</span>

            </SuggestionItem>

          ))}

        </SuggestionsList>

      )}

      {error && <ErrorMessage>{error}</ErrorMessage>}

    </Container>

  );

};



export default LocationAutocomplete; 